<header>
  <mdcr-named-logo (click)="goToMainPage()" />

  @if (isDesktopLayout()) {
    <mdcr-header-action-content data-id="header-explicit-action-content" />
  } @else {
    @if (showFlag()) {
      <img
        data-img="header-close"
        alt="Close"
        height="24"
        width="24"
        [src]="SVG.close"
        (click)="setShowFlag()"
        (keydown)="setShowFlag()"
        tabindex="{0}"
      />
    } @else {
      <img
        data-img="header-menu"
        alt="Menu"
        height="24"
        width="24"
        [src]="SVG.menuHamburger"
        (click)="setShowFlag()"
        (keydown)="setShowFlag()"
        tabindex="{0}"
      />
    }
  }
</header>

@if (!isDesktopLayout()) {
  <div
    class="header-menu"
    [class.active]="showFlag()"
    (click)="setShowFlag()"
    (keydown)="setShowFlag()"
    tabindex="{0}"
  >
    <mdcr-header-action-content />
    <hr />
    <mdcr-contacts />
    <mdcr-agreements-links />
  </div>
}
